import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { S3HOST } from '../../../ApiConstants';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import Fade from 'react-reveal/Fade';
import view from './../../../Enums';
import './index.scss';

class OyoStats extends Component {
  constructor(props) {
    super(props);
    this.getMobileComponent = this.getMobileComponent.bind(this);
  }


  getMobileComponent = () => {

    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && (
          <div className={'oyo_stats_container'}>
            <div className="child_oyo_stats">
              <Fade bottom cascade>
                <div className="imageContainer">
                  <img
                    className="child_oyo_stats_image"
                    src={gi('countries_image')}
                  />
                </div>
                <div className={'child_oyo_text_span'}>
                  <span className="child_oyo_stats_text_big">
                    {gc('no_of_countries')}
                  </span>
                  <span className="child_oyo_stats_text_small">
                    {gc('countries')}
                  </span>
                </div>
              </Fade>
            </div>

            <div className="child_oyo_stats">
              <Fade bottom cascade>
                <div className="imageContainer">
                  <img
                    className="child_oyo_stats_image"
                    src={gi('statue_of_liberty')}
                  />
                </div>
                <div className={'child_oyo_text_span'}>
                  <span className="child_oyo_stats_text_big">
                    {gc('no_of_hotel_in_us')}
                  </span>

                  <span className="child_oyo_stats_text_small">
                    {' '}
                    {gc('hotels_in_us')}
                  </span>
                </div>
              </Fade>
            </div>

            <div className="child_oyo_stats">
              <Fade bottom cascade>
                <div className="imageContainer">
                  <img
                    className="child_oyo_stats_image"
                    src={gi('rooms_image')}
                  />
                </div>
                <div className="child_oyo_text_span">
                  <span className="child_oyo_stats_text_big">
                    {gc('no_of_rooms')}
                  </span>

                  <span className="child_oyo_stats_text_small">
                    {' '}
                    {gc('rooms')}
                  </span>
                </div>
              </Fade>
            </div>

            <div className="child_oyo_stats">
              <Fade bottom cascade>
                <div className="imageContainer">
                  <img
                    className="child_oyo_stats_image"
                    src={gi('oyo_guest_image')}
                  />
                </div>
                <div className="child_oyo_text_span">
                  <span className="child_oyo_stats_text_big">
                    {gc('no_of_guests')}
                  </span>
                  <span className="child_oyo_stats_text_small">
                    {' '}
                    {gc('guests')}
                  </span>
                </div>
              </Fade>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  };

  render() {

    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    if (this.props.viewMode === view.MOBILE) return this.getMobileComponent();
    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && (
          <div
            className={this.props.viewMode == view.MOBILE ? '' : ''}
            style={gs('oyo_stats_container')}
          >
            <div style={gs('child_oyo_stats')}>
              <div style={gs('child_oyo_stats_content')}>
                <Fade bottom cascade>
                  <img
                    style={gs('child_oyo_stats_image')}
                    src={gi('countries_image')}
                  />
                  <span style={gs('child_oyo_text_span')}>
                    <span style={gs('child_oyo_stats_text_big')}>
                      {gc('no_of_countries')}
                    </span>
                    <span style={gs('child_oyo_stats_text_small')}>
                      {gc('countries')}
                    </span>
                  </span>
                </Fade>
              </div>
            </div>

            <div style={gs('child_oyo_stats')}>
              <div style={gs('child_oyo_stats_content')}>
                <Fade bottom cascade>
                  <img
                    style={gs('child_oyo_stats_image')}
                    src={gi('statue_of_liberty')}
                  />
                  <span
                    style={{ ...gs('child_oyo_text_span'), width: '100px' }}
                  >
                    <span
                      style={{
                        ...gs('child_oyo_stats_text_big'),
                        width: '98px'
                      }}
                    >
                      {gc('no_of_hotel_in_us')}
                    </span>

                    <span style={gs('child_oyo_stats_text_small')}>
                      {' '}
                      {gc('hotels_in_us')}
                    </span>
                  </span>
                </Fade>
              </div>
            </div>

            <div style={gs('child_oyo_stats')}>
              <div style={gs('child_oyo_stats_content')}>
                <Fade bottom cascade>
                  <img
                    style={gs('child_oyo_stats_image')}
                    src={gi('rooms_image')}
                  />
                  <span style={gs('child_oyo_text_span')}>
                    <span
                      style={{
                        ...gs('child_oyo_stats_text_big'),
                        width: '76px'
                      }}
                    >
                      {gc('no_of_rooms')}
                    </span>

                    <span style={gs('child_oyo_stats_text_small')}>
                      {' '}
                      {gc('rooms')}
                    </span>
                  </span>
                </Fade>
              </div>
            </div>

            <div style={gs('child_oyo_stats')}>
              <div style={{ ...gs('child_oyo_stats_content'), width: '185px' }}>
                <Fade bottom cascade>
                  <img
                    style={gs('child_oyo_stats_image')}
                    src={gi('oyo_guest_image')}
                  />
                  <span
                    style={{ ...gs('child_oyo_text_span'), width: '100px' }}
                  >
                    <span
                      style={{
                        ...gs('child_oyo_stats_text_big'),
                        width: '76px'
                      }}
                    >
                      {gc('no_of_guests')}
                    </span>
                    <span style={gs('child_oyo_stats_text_small')}>
                      {' '}
                      {gc('guests')}
                    </span>
                  </span>
                </Fade>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OyoStats);
